import dayjs from 'dayjs';
import extendedCustomFormatPlugin from './extendedCustomFormatPlugin';

dayjs.extend(extendedCustomFormatPlugin);

export default dayjs;
